const NotesIcon = ( { className } ) => {
	return (
		
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"
				 className={className}>
			<rect width="56" height="56" rx="16" fill="#85C553"/>
			<path
				d="M29.8668 14.6666H20.0002C19.2929 14.6666 18.6146 14.9476 18.1145 15.4477C17.6144 15.9478 17.3335 16.626 17.3335 17.3333V38.6666C17.3335 39.3739 17.6144 40.0521 18.1145 40.5522C18.6146 41.0523 19.2929 41.3333 20.0002 41.3333H36.0002C36.7074 41.3333 37.3857 41.0523 37.8858 40.5522C38.3859 40.0521 38.6668 39.3739 38.6668 38.6666V28.8"
				stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M14.6665 20H19.9998" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M14.6665 25.3334H19.9998" stroke="white" strokeWidth="2" strokeLinecap="round"
						strokeLinejoin="round"/>
			<path d="M14.6665 30.6666H19.9998" stroke="white" strokeWidth="2" strokeLinecap="round"
						strokeLinejoin="round"/>
			<path d="M14.6665 36H19.9998" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
			<path
				d="M40.5041 19.5014C41.0353 18.9702 41.3337 18.2498 41.3337 17.4987C41.3337 16.7476 41.0353 16.0272 40.5041 15.496C39.973 14.9649 39.2526 14.6665 38.5015 14.6665C37.7503 14.6665 37.0299 14.9649 36.4988 15.496L29.8188 22.1787C29.5018 22.4955 29.2698 22.8871 29.1441 23.3174L28.0281 27.144C27.9947 27.2588 27.9927 27.3804 28.0223 27.4962C28.052 27.6119 28.1122 27.7176 28.1967 27.8021C28.2812 27.8866 28.3869 27.9469 28.5027 27.9765C28.6184 28.0062 28.7401 28.0042 28.8548 27.9707L32.6815 26.8547C33.1117 26.7291 33.5033 26.497 33.8201 26.18L40.5041 19.5014Z"
				stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	
	
	);
};

export default NotesIcon;
